import React from 'react'
import Indexx from '../../Components/client/Index'

function Index() {
  return (
    <div>
      <Indexx/>
    </div>
  )
}

export default Index
